// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const getEmptyValueField = filterSelect => {
  switch (filterSelect) {
    case 'antennaCode' :
    case 'antennaModel' :
      // just check if see if there's a primary assigned, don't look at code or model values.
      return ['antennas', 'primary', 'antennaCode']

    case 'callSign' :
      return ['callSign']

    case 'radioCode' :
      return ['radio', 'radioCode']

    case 'segmentStatus' :
      return ['segmentStatus']

    default :
      throw new Error(`getEmptyValueField error: unmapped selectValue of ${filterSelect}`)
  }
}

export default getEmptyValueField
